export default __webpack_public_path__ + "static/media/earth_normal_map.09c0fe95.png";